jQuery(document).ready(function($){
	//if you change this breakpoint in the style.css file (or _layout.scss if you use SASS), don't forget to update this value as well
	var MqL = 1350;

	//move nav element position according to window width
	// moveNavigation();
	// $(window).on('resize', function(){
	// 	(!window.requestAnimationFrame) ? setTimeout(moveNavigation, 300) : window.requestAnimationFrame(moveNavigation);
	// });

	//mobile - open lateral menu clicking on the menu icon
	// $('.cd-nav-trigger').on('click', function(event){
	// 	event.preventDefault();
	// 	if( $('.cd-main-content').hasClass('nav-is-visible') ) {
	// 		closeNav();
	// 		$('.cd-overlay').removeClass('is-visible');
	// 		$('.cd-nav-trigger')[0].setAttribute('aria-expanded', false);
	// 	} else {
	// 		$('.cd-nav-trigger')[0].setAttribute('aria-expanded', true);
	// 		$(this).addClass('nav-is-visible');
	// 		$('.cd-primary-nav').addClass('nav-is-visible');
	// 		$('.cd-main-header').addClass('nav-is-visible');
	// 		$('.cd-main-content').addClass('nav-is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
	// 			$('body').addClass('overflow-hidden');
	// 		});
	// 		toggleSearch('close');
	// 		$('.cd-overlay').addClass('is-visible');
	// 	}
	// });

	// //open search form
	// $('.cd-search-trigger').on('click', function(event){
	// 	event.preventDefault();
	// 	toggleSearch();
	// 	closeNav();
	// });

	//close lateral menu on mobile 
	// $('.cd-overlay').on('swiperight', function(){
	// 	if($('.cd-primary-nav').hasClass('nav-is-visible')) {
	// 		closeNav();
	// 		$('.cd-overlay').removeClass('is-visible');
	// 	}
	// });
	// $('.nav-on-left .cd-overlay').on('swipeleft', function(){
	// 	if($('.cd-primary-nav').hasClass('nav-is-visible')) {
	// 		closeNav();
	// 		$('.cd-overlay').removeClass('is-visible');
	// 	}
	// });
	// $('.cd-overlay').on('click', function(){
	// 	closeNav();
	// 	toggleSearch('close')
	// 	$('.cd-overlay').removeClass('is-visible');
	// });


	//prevent default clicking on direct children of .cd-primary-nav 
	$('.cd-primary-nav').children('.has-children').children('a').on('click', function(event){
		event.preventDefault();
	});

	//open submenu
	$('.has-children').children('button').on('click', function(event){
		if( !checkWindowWidth() ) event.preventDefault();
		var selected = $(this);
		if( selected.next('ul').hasClass('is-hidden') ) {
			//desktop version only
			selected.addClass('selected').next('ul').removeClass('is-hidden').end().parent('.has-children').parent('ul').addClass('moves-out');
			selected.parent('.has-children').siblings('.has-children').children('ul').addClass('is-hidden').end().children('a').removeClass('selected');
			$('.cd-overlay').addClass('is-visible');
			selected[0].setAttribute('aria-expanded', true);
		} else {
			selected.removeClass('selected').next('ul').addClass('is-hidden').end().parent('.has-children').parent('ul').removeClass('moves-out');
			$('.cd-overlay').removeClass('is-visible');
			selected[0].setAttribute('aria-expanded', false);
		}
		toggleSearch('close');
	});

	//submenu items - go back link
	$('.go-back').on('click', function(){
		$(this).parent('ul').addClass('is-hidden').parent('.has-children').parent('ul').removeClass('moves-out');
	});

	function closeNav() {
		$('.cd-nav-trigger').removeClass('nav-is-visible');
		$('.cd-main-header').removeClass('nav-is-visible');
		$('.cd-primary-nav').removeClass('nav-is-visible');
		$('.has-children ul').addClass('is-hidden');
		$('.has-children button').removeClass('selected');
		$('.moves-out').removeClass('moves-out');
		$('.cd-main-content').removeClass('nav-is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
			$('body').removeClass('overflow-hidden');
		});
	}

	function toggleSearch(type) {
		if(type=="close") {
			//close serach 
			$('.cd-search').removeClass('is-visible');
			$('.cd-search-trigger').removeClass('search-is-visible');
			$('.cd-overlay').removeClass('search-is-visible');
		} else {
			//toggle search visibility
			$('.cd-search').toggleClass('is-visible');
			$('.cd-search-trigger').toggleClass('search-is-visible');
			$('.cd-overlay').toggleClass('search-is-visible');
			if($(window).width() > MqL && $('.cd-search').hasClass('is-visible')) $('.cd-search').find('input[type="search"]').focus();
			($('.cd-search').hasClass('is-visible')) ? $('.cd-overlay').addClass('is-visible') : $('.cd-overlay').removeClass('is-visible') ;
		}
	}

	function checkWindowWidth() {
		//check window width (scrollbar included)
		var e = window, 
            a = 'inner';
        if (!('innerWidth' in window )) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        if ( e[ a+'Width' ] >= MqL ) {
			return true;
		} else {
			return false;
		}
	}

	// function moveNavigation(){
	// 	var navigation = $('.cd-nav');
  // 		var desktop = checkWindowWidth();
  //       if ( desktop ) {
	// 		navigation.detach();
	// 		navigation.insertBefore('.cd-header-buttons');
	// 	} else {
	// 		navigation.detach();
	// 		navigation.insertAfter('.cd-main-content');
	// 	}
	// }
	
	// // Play and pause video element
	// if (document.querySelector('.video-element')) {
	// 	let videos = document.querySelectorAll('.video-element');
	// 	videos.forEach(function(element){
	// 		let video = element.querySelector('.js-video');
	// 		playPauseBtn = element.querySelector('.js-play-pause');
	// 		element.querySelector('.js-play-icon').style.display = 'none';
	// 		playPauseBtn.addEventListener('click', (e) => {
	// 			if (video.paused) {
	// 				video.play();
	// 				playPauseBtn.querySelector('.visually-hidden').textContent = 'Pause';
	// 				playPauseBtn.querySelector('.js-play-icon').style.display = 'none';
	// 				playPauseBtn.querySelector('.js-pause-icon').style.display = 'block';
	// 			} else {
	// 				video.pause();
	// 				playPauseBtn.querySelector('.visually-hidden').textContent = 'Play';
	// 				playPauseBtn.querySelector('.js-play-icon').style.display = 'block';
	// 				playPauseBtn.querySelector('.js-pause-icon').style.display = 'none';
	// 			}
	// 		});
	// 	});
	// }

	// $('#play-pause-button').click(function () {
	// 	var mediaVideo = $("#media-video").get(0);
	// 	if (mediaVideo.paused) {
	// 			mediaVideo.play();
	// 	} else {
	// 			mediaVideo.pause();
	//  }
	// });

	// //June 2021 Update Animations
	// function homePageAnimations() {
	// 	var desktop = false;
	// 	var e = window, 
	// 			a = 'inner';
	// 	if (!('innerWidth' in window )) {
	// 			a = 'client';
	// 			e = document.documentElement || document.body;
	// 	}
	// 	if ( e[ a+'Width' ] >= 768 ) {
	// 		desktop =  true;
	// 	}
	// 	if (desktop) {
	// 		const animationObserver = new IntersectionObserver(entries => {
	// 			// Loop over the entries
	// 			entries.forEach(entry => {
	// 				// If the element is visible
	// 				if (entry.isIntersecting) {
	// 					let animation = entry.target.dataset.animated,
	// 							delay = entry.target.dataset.delay;
	// 					// Add the animation class
	// 					entry.target.classList.add('animated');
	// 					entry.target.classList.add(delay);
	// 					entry.target.classList.add(animation);
	// 				}
	// 			});
	// 		});
			
	// 		let animatedElements = Array.from(document.getElementsByClassName('js-anim-elem'));
		
	// 		animatedElements.forEach(elem => {
	// 			animationObserver.observe(elem);
	// 		})
	// 	}
	// }

	// if (document.getElementById('luv-aj') || document.querySelector('.js-anim-elem')) {
	// 	// instagramSections();
	// 	homePageAnimations();
	// }

  // if (document.querySelector('.collection-masonry')) {
  //   console.log('masonry');
  //   let collection = document.querySelector('.collection-masonry');
  //   var msnry = new Masonry( collection, {
  //     // options
  //     itemSelector: '.masonry-product',
  //     columnWidth: '.masonry-sizer',
  //     percentPosition: true,
  //     gutter: 12,
  //     horizontalOrder: true
  //   });
  // }

});